
import { computed, ref } from 'vue'
import type { PronunciationCollection } from '@/types/PronunciationCollection'

export const usePronunciationCollection = (pronunciationCollection: PronunciationCollection) => {
  const pageSize = 10
  const currentPage = ref(1)

  const currentPageIds = computed(() => {
    if (!pronunciationCollection.pagination) return pronunciationCollection.pronunciationIds

    const startIndex = (currentPage.value - 1) * pageSize
    const endIndex = startIndex + pageSize
    
    return pronunciationCollection.pronunciationIds.slice(startIndex, endIndex) || []
  })

  const setPage = (page: number) => {
    currentPage.value = page
  }

  return {
    currentPageIds,
    setPage,
    pageSize // for testing purposes
  }
}